// work data

export const Work = [
    {
        id:1,
        name:"E-Commerce_MERN_App",
        description:"A responsive e-commerce web application that is built using MERN Stack.",
        tags:["react","MERN","styledComponents"],
        
        demo:"https://github.com/mr-robot-abhi/E-Commerce_MERN_App",
        github:"https://github.com/mr-robot-abhi/E-Commerce_MERN_App"
    },
    {
        id:2,
        name:"Amazon - Clone",
        description:"Amazon Clone that actually works.",
        tags:["react","sass","react-router"],
        
        demo:"https://github.com/mr-robot-abhi/Amazone_Clone_ReactJs-master",
        github:"https://github.com/mr-robot-abhi/Amazone_Clone_ReactJs-master"
        
    },
    {
        id:3,
        name:"Real-Time Chat App",
        description:"A real-time chat application built using MERN Stack, JWT and Socket.io",
        tags:["MERN","api","socket.io"],
        
        demo:"https://github.com/mr-robot-abhi/MERN_chat_app",
        github:"https://github.com/mr-robot-abhi/MERN_chat_app"
    },
    {
        id:4,
        name:"Linkedin Clone",
        description:"Linkedin Clone with MERN Stack, JWT and Mailtrap",
        tags:["MERN","JWT","Mailtrap"],
        
        demo:"https://github.com/mr-robot-abhi/LinkedIn_Clone_MERN",
        github:"https://github.com/mr-robot-abhi/LinkedIn_Clone_MERN"
       
    },{
        id:5,
        name:"ChatGPT Assistant",
        description:"It serves as a basic demonstration of utilizing OpenAI's models for text generation, image generation, and speech-to-text functionalities",
        tags:["react","expo","typescript"],
        
        demo:"https://github.com/mr-robot-abhi/ChatGpt-Dall-E-Assistant/tree/main/ChatGPT-Assistant-main",
        github:"https://github.com/mr-robot-abhi/ChatGpt-Dall-E-Assistant/tree/main/ChatGPT-Assistant-main"
        
    },
    {
        id:6,
        name:"Pokémon Search App",
        description:"A responsive web application for searching and viewing details of Pokémon, built using Next.js, React, Tailwind CSS, and the PokéAPI.",
        tags:["nextjs","tailwind","Poke API","Axios"],
        
        demo:"https://github.com/mr-robot-abhi/pokemon_search_app",
        github:"https://github.com/mr-robot-abhi/pokemon_search_app"
        
    },
    
  
] 
